<div class="overlay spinner"
     *ngIf="visible"
>
  <div #spinnerContent class="spinner-content">
    <progress-symbol [mode]="mode" [value]="progress">
    </progress-symbol>

    <div *ngIf="progressType == progressTypeEnum.Final" class="text-wrapper">
      <p translate>
        i18n.progressOverlay.message.lines.one
      </p>
      <p translate>
        i18n.progressOverlay.message.lines.two
      </p>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/progress-overlay/progress-overlay.component.html